export const ARROW_LABEL = '→';
